import React, { useRef } from 'react';
import MathToolbar from './MathToolbar';

/**
 * A textarea with MathToolbar for entering math symbols, Greek letters, etc.
 */
const MathTextarea = ({ 
  value, 
  onChange, 
  placeholder = '',
  rows = 3,
  className = '',
  required = false,
  'data-testid': dataTestId,
}) => {
  const textareaRef = useRef(null);

  return (
    <div className="w-full">
      <MathToolbar 
        textareaRef={textareaRef}
        value={value}
        onChange={onChange}
      />
      <textarea
        ref={textareaRef}
        data-testid={dataTestId}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full px-4 py-3 rounded-b-lg border border-slate-200 border-t-0 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${className}`}
        rows={rows}
        placeholder={placeholder}
      />
    </div>
  );
};

export default MathTextarea;
